interface MapToOptionsParams<T> {
  data: T[] | undefined
  valueKey: keyof T
  labelKey: keyof T
  defaultLabel?: string
}

interface Option {
  value: string
  label: string
}

export function mapToOptions<T>({
  data,
  valueKey,
  labelKey,
  defaultLabel = 'Без имени',
}: MapToOptionsParams<T>): Option[] {
  if (!data) {
    return []
  }
  return data.map((item) => ({
    value: String(item[valueKey]),
    label: item[labelKey] ? String(item[labelKey]) : defaultLabel,
  }))
}
